// extracted by mini-css-extract-plugin
module.exports = {"root":"IdFormatter_root__7zgR7"};